import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoveRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.42871 11.6016C0.888672 11.6016 0.649414 11.1846 0.587891 10.8086C0.526367 10.4941 0.512695 10.125 0.512695 9.72852C0.512695 6.57715 1.85254 5.08691 4.96289 5.08691H9.29687L10.8965 5.18262L9.06445 3.52148L7.54004 1.9834C7.38281 1.82617 7.28027 1.62109 7.28027 1.375C7.28027 0.910156 7.62891 0.561523 8.12109 0.561523C8.33301 0.561523 8.54492 0.650391 8.73633 0.834961L13.207 5.30566C13.3848 5.47656 13.4805 5.70898 13.4805 5.94141C13.4805 6.17383 13.3848 6.41309 13.207 6.57715L8.72266 11.0547C8.54492 11.2324 8.33301 11.3213 8.12109 11.3213C7.62891 11.3213 7.28027 10.9727 7.28027 10.5078C7.28027 10.2617 7.38281 10.0498 7.54004 9.89941L9.06445 8.36133L10.9033 6.7002L9.29687 6.7959H5.0791C2.9873 6.7959 2.23535 7.65039 2.23535 9.7627C2.23535 10.1797 2.2627 10.4805 2.2627 10.7539C2.2627 11.2598 1.92773 11.6016 1.42871 11.6016Z",
		fill: "currentColor"
	})
});
export default SvgMoveRight;
